import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';
export const getPublicReservationSettings = async (unitId: string) => {
  const result = await httpsCallable<{unitId:string},{settings:Record<string,any>|null}>(functions,'getPublicReservationSettings')({unitId});
  return { exists: () => result.data.settings !== null, data: () => result.data.settings };
};
